// Robust referral capture: persist a `?ref=` code the moment a visitor lands
// with it (any route), then submit it after authentication. This survives the
// fragile paths the signup-time capture missed — Google OAuth popups, landing on
// the homepage/pricing before registering, or logging in instead of registering.
import { billingApi } from './billing';

const KEY = 'pitto_ref';

/** Store a `?ref=<code>` from a URL query string, if present and plausible. */
export function captureReferralFromUrl(search: string): void {
  const code = new URLSearchParams(search).get('ref');
  if (code && /^[A-Za-z0-9]{4,32}$/.test(code)) {
    localStorage.setItem(KEY, code);
  }
}

/** The stored referral code, if any (used by the Register banner). */
export function storedReferralCode(): string | null {
  return localStorage.getItem(KEY);
}

/**
 * After auth, attach a stored referral (best-effort, non-blocking). On a
 * definitive result (claimed or rejected) the code is cleared; a transient
 * network error keeps it for a later attempt.
 */
export async function claimStoredReferral(): Promise<void> {
  const code = localStorage.getItem(KEY);
  if (!code) return;
  try {
    await billingApi.claimReferral(code);
    localStorage.removeItem(KEY);
  } catch {
    // Token not ready / transient — leave the code for the next auth.
  }
}
